import React, { useState } from "react";
import Terminal from "./terminal";

const MessageForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    email: "",
    phone: "",
    message: "",
  });

  const [message, setMessage] = useState("");

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const hasValue = (value) => value.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, organization, email, phone, message } = formData;

    const emailValid = validateEmail(email);
    const nameValid = hasValue(name);
    const messageValid = hasValue(message);

    if (emailValid && nameValid && messageValid) {
      const data = {
        name: name,
        company: organization,
        email: email,
        phone: phone,
        message: message
      };

      try {
        await fetch("https://api.dev.acebit.se/contact/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        setMessage("Ditt meddelande har skickats!");
      } catch (error) {
        setMessage("Ett fel inträffade när meddelandet skickades.\n\nFörsök igen senare.");
      }
    } else {
      setMessage("Ditt meddelande har inte skickats.\n\nSäkerställ att de obligatoriska fälten är ifyllda korrekt.");
    }
  };

  return (
    <div className="w-full">
      <Terminal title="contact" onClose={onClose}>
        {message ? <div className="flex">{message}</div> :
          <form id="contact-form" className="flex flex-col gap-2" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Namn"
              value={formData.name}
              onChange={handleChange}
              required
              className="input"
            />
            <input
              type="text"
              name="organization"
              placeholder="Företag"
              value={formData.organization}
              onChange={handleChange}
              className="input"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input"
            />
            <input
              type="text"
              name="phone"
              placeholder="Telefon"
              value={formData.phone}
              onChange={handleChange}
              className="input"
            />
            <textarea
              name="message"
              placeholder="Meddelande"
              value={formData.message}
              onChange={handleChange}
              required
              className="input min-h-32 resize-none"
            />
            <div className="w-full">
              <button type="submit" className="btn-primary mt-2 w-full">
                Skicka
              </button>
            </div>
          </form>
        }
      </Terminal>
    </div>
  );
};


export default MessageForm;